import { KCommandBase, CommandEnv } from './cmdkTypes'
import { KAction, toAction } from './kcommands/toAction'
import { KNavigate, toNavAction } from './kcommands/toNavAction'
import { KRun, toRunAction } from './kcommands/toRunAction'

/**
 * A function type to create an executable action, given a KCommand and environment
 */
type Actionizer<T extends KCommandBase> = (this: T, env: CommandEnv) => () => void

function make<T extends KCommandBase>(act: Actionizer<T>) {
  return (init: T) => ({ ...init, toAction: act })
}

/**
 * A mostly trivial command type, it has a pre-defined action called with the query text.
 *
 * It has no access to app controls, only basic window stuff like open a tab to etherscan.
 */
export const actionCommand = make<KAction>(toAction)

/**
 * A navigation command, it goes to a specific location in the app,
 * with some optional state passed through history.location.state.
 *
 * It enables controlling the state of the destination page to toggle dialogs,
 * prepopulate inputs etc - see sample helpers in useCommandState.ts
 *
 * It can be executed even when the user is already at the location.
 */
export const navCommand = make<KNavigate>(toNavAction)

/**
 * The most general command type, it has full access to app controls and no preset behaviors.
 *
 * It can be used to script anything, from calling backend APIs to clicking buttons,
 * to sending the query text to an LLM and managing app global state from the response.
 */
export const runCommand = make<KRun>(toRunAction)
